import { render } from "./NuevoPedido.vue?vue&type=template&id=29fc5c1c&scoped=true"
import script from "./NuevoPedido.vue?vue&type=script&lang=js"
export * from "./NuevoPedido.vue?vue&type=script&lang=js"

import "./NuevoPedido.vue?vue&type=style&index=0&id=29fc5c1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fc5c1c"]])

export default __exports__